import axios from "axios";
import {baseUrl} from "../../../utils/apis";
import {generateRandomId} from "../../../utils/helpers/browserID";

const ee_device_id = localStorage.getItem("ee-device-id");
!ee_device_id && localStorage.setItem("ee-device-id", generateRandomId());

const urls = {login: `${baseUrl}/auth/login/`};

const authApi = async (payload) => {
  const {email, password} = payload;

  try {
    const formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);

    const response = await axios.post(urls.login, formData);

    return response;
  } catch (err) {
    console.error("error", err);
    throw err;
  }
};

export {authApi};
